// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5060ef61","946":"8e3a3343"}[chunkId] + ".chunk.js";
};